module.exports = __webpack_public_path__ + "img/INVOICE.6d7a5a72.svg";